export default __webpack_public_path__ + "static/media/hbs-bpk-banner-3.fc97ff34.jpg";